import { action, makeObservable, observable, runInAction } from "mobx";
import { UserManager, type User, type UserManagerSettings } from "oidc-client-ts";

const SUPER_ADMIN_EMAILS = new Set(["georges@randmar.io", "d@randmar.io", "jpundyk@randmar.io"]);

const config: UserManagerSettings = {
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: "js",
  redirect_uri: `${window.location.origin}${import.meta.env.VITE_REDIRECT_URI
    }`,
  response_type: "code",
  response_mode: "query",
  scope: "openid",
  post_logout_redirect_uri: `${window.location.origin}${import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI
    }`
};

export const manager = new UserManager(config);
manager.events.addAccessTokenExpired(() => {
  manager.removeUser().then(() => {
    window.location.href = `${import.meta.env.VITE_RANDMAR_HOME}`;
  });
});

export default class UserStore {
  user?: User;

  constructor() {
    makeObservable(this, {
      user: observable,
      storeUser: action.bound
    });
  }

  public signIn() {
    const state = window.location.pathname + window.location.search + window.location.hash;
    manager.signinRedirect({ state });
  }

  public signOut() {
    manager.signoutRedirect({ post_logout_redirect_uri: `https://www.randmar.io` })
  }

  public getApplicationName(): string {
    const value = (this.user?.profile as Record<string, unknown> | undefined)?.["ApplicationName"];
    return typeof value === "string" ? value : "";
  }

  public getApplicationId(): string {
    const value = (this.user?.profile as Record<string, unknown> | undefined)?.["ApplicationId"];
    if (typeof value === "string") return value;
    if (typeof value === "number") return String(value);
    return "";
  }

  async storeUser(user: User) {
    this.user = user;
    localStorage.setItem('access_token', user.access_token);
    await manager.storeUser(user);
  }

  async getUser() {
    const user = await manager.getUser();

    runInAction(() => {
      this.user = user || undefined;
    });

    return user;
  }

  public isAdmin(): boolean {
    return this.getApplicationId() === "2";
  }

  public isSuperAdmin(): boolean {
    return SUPER_ADMIN_EMAILS.has(this.getApplicationName()) && this.isAdmin();
  }
}
